<script>
export default {}
</script>

<template>
  <v-layout
    align-center
    justify-center
    row
    fill-height
  >
    <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
    />
  </v-layout>
</template>

<style lang="scss" module>
</style>
